/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Box from '@material-ui/core/Box';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Paper from '@material-ui/core/Paper';
import { Button } from '@material-ui/core';
import firebase from '../../../config/config';
import logger from '../../../utils/logger.js';
import {
  deleteFileHandlerNew,
  fileUploaderNew,
  getSignedURLNew,
  getViewURLNew,
} from '../../../utils/fileUploadHandler';
import convertTimestampToDate from '../../../utils/convertTimestampToDate';
import { mappedCurrentActiveRole } from '../../../utils/roleMapping.js';

const useStyles = makeStyles({
  box: {
    borderRadius: '5px',
    textAlign: 'left',
    border: '2px dashed',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  viewButton: {
    background: '#52BE56',
    color: 'white',
    margin: '0px 10px 0px 0px',
    padding: '5px 10px',
  },
  nameTabs: {
    display: 'flex',
    flexDirection: 'column',
  },
  promptBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  alert: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '2px dashed lightgray',
    borderRadius: '5px',
  },
  deleteModalButton: {
    width: '45%',
    background: '#52BE56',
    borderRadius: 0,
    color: 'white',
    margin: '5px',
  },
  cancelButton: {
    width: '45%',
    background: 'lightgray',
    borderRadius: 0,
    margin: '5px',
  },
});

const contentStyle = { width: '24%' };

const inlineCheckIconStyle = {
  color: '#52BE56',
};

const nameBoxStyles = {
  display: 'flex',
  margin: '10px 0px 0px 8px',
  gap: '5px',
  alignItems: 'center',
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const paperStyles = { padding: 10, marginTop: 10 };
const AdhaarFileUpload = ({
  truckerId,
  activeRole,
  multiStep,
  aadharBackUpload,
  fileDetails,
  refetch,
}) => {
  const {
    aadhar_back_path: isAadharAvailable,
    aadhar_back_uploaded_by: uploadedBy,
    aadhar_back_uploaded_at: uploadedAt,
  } = fileDetails || {};
  const [loading, setLoading] = useState(false);
  const [user, setUser] = React.useState();
  const [success, setSuccess] = useState(false);
  const [deleted, setDeleted] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const auditLog = firebase.functions().httpsCallable('utilities-auditLog');
  const classes = useStyles();

  const onDrop = async acceptedFiles => {
    setOpen(!open);
    // Do something with the files
    const UploadedFile = acceptedFiles[0];
    const body = {
      file_type: 'trucker_aadhaar_back',
      trucker_id: truckerId,
      role: mappedCurrentActiveRole(activeRole),
    };
    getSignedURLNew(body, UploadedFile)
      .then(response => {
        const { url: signedURL, metadata } = response?.data;
        fileUploaderNew(signedURL, metadata, UploadedFile)
          .then(res => {
            setTimeout(() => {
              refetch();
              setOpen(false);
            }, 4000);
          })
          .catch(e => {
            setOpen(false);
            aadharBackUpload(false);
          });
      })
      .catch(e => setOpen(false));
  };
  // ------------------------------------------//
  async function DeleteAdhaarFile() {
    setOpen(true);
    const body = {
      scope: 'trucker',
      file_type: 'AdhaarBack',
      org_id: truckerId,
      role: mappedCurrentActiveRole(activeRole),
    };
    try {
      await deleteFileHandlerNew(body);

      setOpen(false);
      setDeleted(true);
      refetch();
      const auditBody = {
        // data: { ...transaction },
        collection: 'file uploads',
        adhaarFileDeletedBy: user.uid,
        type: 'Deleted Adhaar File in Truckers',
        message: `${user.email} in file uploads collection inside Truckersfile doc inside Adhaar collection with ${truckerId} Truckers ID deleted the file `,
        deletedAt: new Date(),
      };
      auditLog(auditBody);
    } catch (e) {
      setOpen(false);
      logger.error(e);
    }
  }
  function handleClose() {
    setDeleted(false);
    setSuccess(false);
  }

  const { getRootProps, getInputProps } = useDropzone({
    acceptedFiles: {
      'image/png': ['.png', '.jpeg', '.jpg'],
      'application/pdf': ['.pdf'],
    },
    onDrop,
  });
  const viewFile = url => {
    window.open(url);
  };

  async function getAdhaarBackData() {
    setLoading(true);
    const viewURLBody = {
      role: mappedCurrentActiveRole(activeRole),
      file_type: 'trucker_aadhaar_back',
      trucker_id: truckerId,
    };
    getViewURLNew(viewURLBody)
      .then(result => {
        viewFile(result?.data?.file_details?.url);
        setLoading(false);
      })
      .catch(e => {
        logger.error('error', e);
        setLoading(false);
      });
  }

  useEffect(() => {
    const userDetails = firebase.auth().currentUser;
    setUser(userDetails);
  }, []);

  return (
    <Paper elevation={1} style={paperStyles}>
      {(activeRole == 'sales' ||
        activeRole == 'branch-ops' ||
        activeRole == 'traffic' ||
        multiStep) && (
        <>
          <div className={classes.headerWrapper}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p
                style={{
                  margin: '8px',
                  textAlign: 'left',
                  fontSize: '20px',
                  fontWeight: 400,
                }}
              >
                Aadhaar (Back)
              </p>
              {isAadharAvailable && (
                <CheckCircleIcon
                  style={inlineCheckIconStyle}
                  fontSize="small"
                />
              )}
            </div>
            {isAadharAvailable && (
              <Box>
                <Button
                  variant="contained"
                  color="success"
                  size="small"
                  className={classes.viewButton}
                  onClick={() => getAdhaarBackData()}
                  startIcon={<VisibilityIcon />}
                  disabled={loading}
                >
                  View {loading && <CircularProgress size={8} />}
                </Button>
              </Box>
            )}
          </div>
          <Box>
            {!isAadharAvailable ? (
              <Box className={classes.container}>
                {open ? (
                  <CircularProgress
                    style={{ color: '#FCD21F', margin: '5px' }}
                    size={30}
                    thickness={8}
                  />
                ) : (
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        marginTop: 5,
                      }}
                    >
                      <CloudUploadIcon />
                      <p style={{ fontSize: '10px', color: 'gray', margin: 0 }}>
                        Drag and Drop or Click here to upload
                      </p>
                    </div>
                  </div>
                )}
              </Box>
            ) : (
              <div style={nameBoxStyles}>
                <p
                  style={{
                    fontWeight: 'bold',
                    margin: 0,
                    fontSize: '12px',
                  }}
                >
                  {uploadedBy}
                </p>
                <CircleIcon style={{ fontSize: '10px' }} />
                <p
                  style={{
                    color: '#a9a9a9',
                    fontSize: '10px',
                    margin: 0,
                  }}
                >
                  {convertTimestampToDate(uploadedAt)}
                </p>
              </div>
            )}
          </Box>
        </>
      )}
      {(activeRole == 'ops' ||
        activeRole == 'approval' ||
        activeRole == 'finance' ||
        activeRole == 'finance-payable' ||
        activeRole == 'finance-recievable' ||
        activeRole == 'finance-recon' ||
        activeRole == 'partner-exec-manager') && (
        <Box>
          {!isAadharAvailable ? (
            <div>
              <p
                style={{
                  margin: '8px',
                  textAlign: 'left',
                  fontSize: '20px',
                  fontWeight: 400,
                }}
              >
                Aadhaar (Back)
              </p>
              <p style={{ margin: '0 0 10px 8px' }}>No File Uploaded </p>
            </div>
          ) : (
            <>
              <div className={classes.headerWrapper}>
                <div className={classes.nameTabs}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <p
                      style={{
                        margin: '8px',
                        textAlign: 'left',
                        fontSize: '20px',
                        fontWeight: 400,
                      }}
                    >
                      Aadhaar (Back)
                    </p>
                    {isAadharAvailable && (
                      <CheckCircleIcon
                        style={inlineCheckIconStyle}
                        fontSize="small"
                      />
                    )}{' '}
                    {open && (
                      <CircularProgress
                        style={{ color: '#FCD21F', margin: '5px' }}
                        size={30}
                        thickness={8}
                      />
                    )}
                  </div>
                  <div style={nameBoxStyles}>
                    <p
                      style={{
                        fontWeight: 'bold',
                        margin: 0,
                        fontSize: '12px',
                      }}
                    >
                      {uploadedBy}
                    </p>
                    <CircleIcon style={{ fontSize: '10px' }} />
                    <p
                      style={{
                        color: '#a9a9a9',
                        fontSize: '10px',
                        margin: 0,
                      }}
                    >
                      {convertTimestampToDate(uploadedAt)}
                    </p>
                  </div>
                </div>
                {isAadharAvailable ? (
                  <Box>
                    <div className={classes.promptBox}>
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        className={classes.viewButton}
                        onClick={() => getAdhaarBackData()}
                        startIcon={<VisibilityIcon />}
                        disabled={loading}
                      >
                        View {loading && <CircularProgress size={8} />}
                      </Button>
                      {(activeRole === 'ops' || activeRole === 'approval') && (
                        <Popup
                          trigger={
                            <IconButton
                              color="primary"
                              aria-label="upload picture"
                              component="span"
                              size="small"
                            >
                              <DeleteOutlineIcon color="error" />
                            </IconButton>
                          }
                          modal
                          {...{
                            contentStyle,
                          }}
                        >
                          {close => (
                            <div
                              style={{
                                padding: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <HighlightOffIcon
                                fontSize="large"
                                color="error"
                              />
                              <h4 style={{ fontWeight: 'bold' }}>
                                Are You Sure?
                              </h4>
                              <p>
                                If you proceed, you will not be able to recover
                                it
                              </p>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  width: '100%',
                                  justifyContent: 'center',
                                }}
                              >
                                <Button
                                  onClick={close}
                                  className={classes.cancelButton}
                                >
                                  No
                                </Button>
                                <Button
                                  onClick={DeleteAdhaarFile}
                                  className={classes.deleteModalButton}
                                  disabled={deleted}
                                >
                                  Yes
                                </Button>
                              </div>
                            </div>
                          )}
                        </Popup>
                      )}
                    </div>
                  </Box>
                ) : (
                  ''
                )}
              </div>
            </>
          )}
        </Box>
      )}
      <Snackbar open={deleted} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          Deleted File!
        </Alert>
      </Snackbar>
      <Snackbar open={success} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          Uploaded File!
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default AdhaarFileUpload;
